export default "__VITE_ASSET__5ZmDoisZ__"